import axios from 'axios'
const CryptoJS = require("crypto-js");
const AES = require("crypto-js/aes");
// //AES对称加密
let secretkey = "T68y"; //唯一（公共）秘钥

let isone = 0
// //加密
// encrypt(a,skey = secretkey) {
//   return AES.encrypt(a,skey).toString()
//   // const content = a;
//   // const cipher = crypto.createCipher('aes192', skey); //使用aes192加密
//   // let enc = cipher.update(content, 'utf8', 'hex'); //编码方式从utf-8转为hex;
//   // return (enc += cipher.final('hex')); //编码方式转为hex;
// }
// //解密
// decrypt(a,skey = secretkey) {
//   return AES.decrypt(a,skey).toString(CryptoJS.enc.Utf8)
//   // let enc = a;
//   // //AES对称解密
//   // const decipher = crypto.createDecipher('aes192', skey);
//   // let dec = decipher.update(enc, 'hex', 'utf8');
//   // dec += decipher.final('utf8');
//   // // console.log('AES对称解密结果：' + dec);
//   // return dec
// }
//加密
function encrypt(a,skey = secretkey){
  return AES.encrypt(a,skey).toString()
}
//解密
function decrypt(a,skey = secretkey){
  return AES.decrypt(a,skey).toString(CryptoJS.enc.Utf8)
}
function Setcookie (name, value){
  //设置名称为name,值为value的Cookie
  var expdate = new Date();   //初始化时间
  expdate.setTime(expdate.getTime() + 30 * 365 * 86400000);   //时间
  document.cookie = name+"="+value+";expires="+expdate.toGMTString()+";path=/";
  //即document.cookie= name+"="+value+";path=/";   时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
}
function getCookie(c_name){
if (document.cookie.length>0){
  let c_start=document.cookie.indexOf(c_name + "=")
  if (c_start!=-1){ 
    c_start=c_start + c_name.length+1 
    let c_end=document.cookie.indexOf(";",c_start)
    if (c_end==-1) c_end=document.cookie.length
    return unescape(document.cookie.substring(c_start,c_end))
    } 
  }
  return ""
}

function insertStr(soure, start, newStr){   
  return soure.slice(0, start) + newStr + soure.slice(start);
}

const zmarr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
//返回加密字符串token
function gettoken(){
  const k = zmarr[Math.floor(Math.random()*26)]
  const n = Math.floor(Math.random()*26)
  const ttoken = encrypt(global.tcon,k)
  // console.log(ttoken);
  const newtoken = insertStr(ttoken,n,k);
  // console.log(newtoken);
  // console.log(insertStr(newtoken, 33, zmarr[n]));
  return insertStr(newtoken, 33, zmarr[n])
  // return 'U2FsdGVkX1+zDf35amslfaMIf89ZJeXSXu501qpSKKoBo='
}

// 如果无cookie Hq_nvt_2496e2386f 判断是否是首次访问 
function testquest(){
  let Hq_nvt_2496e2386f = undefined
  Hq_nvt_2496e2386f = getCookie('Hq_nvt_2496e2386f')
  if(Hq_nvt_2496e2386f == ''){
    try{
      let cs = getCookie('connect.skval'),fp = getCookie('fpid')
      if(cs != '' || fp != '' || isone != 0){
        return false
      }else{
        Setcookie('Hq_nvt_2496e2386f',encrypt(JSON.stringify({time:Date.now(),num:1})))
        Setcookie('connect.skval',encrypt(JSON.stringify({isone:1})))
        Setcookie('fpid',encrypt(JSON.stringify({isone:1})))
        isone = 1
        return true
      }
    }catch(e){
      return true
    }
  }
  try{
    Hq_nvt_2496e2386f = JSON.parse(decrypt(getCookie('Hq_nvt_2496e2386f')))
    const oldtime = Hq_nvt_2496e2386f.time
    let questnum = Hq_nvt_2496e2386f.num
    if(!oldtime || !questnum){throw new Error('error')}
    const nowtime = Date.now()
    if(nowtime - oldtime < 20000){
      if(questnum > 75){
        throw new Error('more')
      }
      questnum ++
      Setcookie('Hq_nvt_2496e2386f',encrypt(JSON.stringify({time:oldtime,num:questnum})))
    }else{
      Setcookie('Hq_nvt_2496e2386f',encrypt(JSON.stringify({time:Date.now(),num:1})))
    }
    return true
  }catch(e){
    // console.log(e);
    return false
  }
}

function reqtest(config){
  const result = testquest()
  if(!result){
    console.log('异常 需要验证');
    // console.log(global.aid);
    let captcha = new TencentCaptcha(`${2094946134}`,(rsp) => {
      console.log(rsp)
      //当ret是0得时候代表成功填写了验证码，我在里面进行了axios操作。
      if (rsp.ret === 0){
        // console.log('验证通过');
        Setcookie('Hq_nvt_2496e2386f',encrypt(JSON.stringify({time:Date.now(),num:1})))
        return config
      }else{
        Setcookie('Hq_nvt_2496e2386f','')
      }
    },{})
    captcha.show()
  }else{
    return config
  }
}

//携带token
function addtoken(config){
  config.headers['accessToken'] = gettoken()
  return config
}

export function myrequest(config){
  const instance = axios.create({
    baseURL:'https://tymodule.com/api', //上线 http://localhost:3000/api  https://tymodule.com/api
    withCredentials:'include', //跨域设置cookie相关
    timeout:60000
  })
  instance.interceptors.request.use(config =>{
    config = reqtest(config)
    config = addtoken(config)
    return config
  },err=>{
    console.log(err);
  })
  instance.interceptors.response.use(res=>{
    return res.data
  },err=>{
    console.log(err);
  })
  return instance(config)
}

export function myrequest_nt(config){
  const instance = axios.create({
    baseURL:'https://tymodule.com/api', //上线 http://localhost:3000/api  https://tymodule.com/api
    withCredentials:'include', //跨域设置cookie相关
    timeout:60000
  })
  instance.interceptors.request.use(config =>{
    config = addtoken(config)
    return config
  },err=>{
    console.log(err);
  })
  instance.interceptors.response.use(res=>{
    return res.data
  },err=>{
    console.log(err);
  })
  return instance(config)
}

export function localrequest(config){
  const instance = axios.create({
    baseURL:'http://localhost:50179',
    // withCredentials:'include', //跨域设置cookie相关
    timeout:60000
  })
  instance.interceptors.request.use(config =>{
    config = reqtest(config)
    return config
  },err=>{
    // console.log(err);
  })
  instance.interceptors.response.use(res=>{
    return res.data
  },err=>{
    // console.log(err);
  })
  return instance(config)
}